import React, { useEffect } from 'react';
import { AlertTriangle, X } from 'lucide-react';

const PrefixDeleteModal = ({
  open,
  onClose,
  onConfirm,
  loading,
  type = 'Admission',
}) => {
  useEffect(() => {
    if (!open) return;
    const handleEscape = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm transition-opacity duration-300" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full relative overflow-hidden" role="dialog" aria-modal="true">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors" disabled={loading}>
          <X size={20} />
        </button>
        <div className="p-6 flex flex-col items-center text-center">
          <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-red-100 mb-6 animate-bounce-short">
            <AlertTriangle className="h-8 w-8 text-red-600" />
          </div>
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Delete {type} Prefix?
          </h3>
          <p className="text-gray-600 mb-6 text-sm">
            Are you sure you want to delete the {type.toLowerCase()} prefix? This will remove it from all {type === 'USN' ? 'USN numbers' : 'student admission numbers'}.
          </p>
          <div className="flex gap-3 w-full justify-center">
            <button onClick={onClose} disabled={loading} className="px-4 py-2 rounded-lg bg-gray-200 text-gray-700 font-medium hover:bg-gray-300 transition-colors">Cancel</button>
            <button onClick={onConfirm} disabled={loading} className="px-4 py-2 rounded-lg bg-red-600 text-white font-medium hover:bg-red-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">{loading ? 'Deleting...' : 'Delete'}</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrefixDeleteModal;
